import React, { Fragment, useState, useEffect } from "react";
import { GetData, ShowData, checkEmpty } from "./Components/services";
import Loading from "../../Common/Loading";
import SplitData from "../../Common/SplitData";
import { Helmet } from "react-helmet";

function Index({ isApp }) {
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);
  const Handler = () => {
    setstate({ ...state, loading: true });
    GetData().then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    Handler();
    scrollToTop();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>قوانین سایت | نیکوتن</title>
        <meta name="description" content={"قوانین سایت"} />
      </Helmet>

      <div className={!isApp && "container my-5"}>
        <div className="row justify-content-lg-center" id={"#rules"}>
          <div className={`col-lg-9 col-sm-12 ${isApp && "nfs-12"}`}>
            {state.loading ? (
              <Loading count={1} col={12} height={300} />
            ) : (
              <Fragment>
                <div>
                  {!isApp && <h3 className="rules-topict mb-4" id="rules">
                    قوانین سایت نیکوتن
                  </h3>}
                  {checkEmpty ? (
                    <p>
                      <SplitData data={ShowData(state.data, "Rules")} />
                    </p>
                  ) : (
                    <p>اطلاعات موجود نیست</p>
                  )}
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Index;
